import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposMedioPagoVenta } from 'constants/index'

const TipoMedioPagoVentaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-tipoMedioPagoVenta' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoMedioPagoVenta'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-tipoMedioPagoVenta'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {TiposMedioPagoVenta.__array.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoMedioPagoVentaFormGroup)
